import React from 'react';

interface ChatHeaderProps {
  showSourcesTab?: boolean;
  showSettingsPanel?: boolean;
  onToggleSourcesTab?: () => void;
  onToggleSettingsPanel?: () => void;
  onToggleSidebar?: () => void;
  isMobile?: boolean;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ 
  showSourcesTab = false,
  showSettingsPanel = false,
  onToggleSourcesTab,
  onToggleSettingsPanel,
  onToggleSidebar,
  isMobile = false
}) => {
  // No need to track sidebar state anymore
  
  return (
    <div className="flex items-center justify-between h-16 px-4 border-b border-divider bg-component">
      <div className="flex items-center gap-3">
        {/* Menu toggle button - only shown on mobile */}
        {onToggleSidebar && isMobile && (
          <button
            onClick={onToggleSidebar}
            className="flex items-center justify-center p-2 rounded-lg hover:bg-hover text-tertiary"
            title="Toggle Menu"
            aria-label="Toggle Menu"
          >
            <svg 
              className="h-6 w-6" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        )}
        <h1 className="text-lg font-medium text-primary truncate whitespace-nowrap">zkML Research Assistant</h1>
      </div>
      
      <div className="flex items-center gap-3">
        {/* Settings toggle button - always shown */}
        <button
          onClick={onToggleSettingsPanel}
          className={`flex items-center px-2 py-1 rounded-lg text-sm font-medium ${
            showSettingsPanel ? "bg-accent-main text-primary-inverse" : "hover:bg-hover text-tertiary"
          }`}
          title="API Settings"
        >
          <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          Settings
        </button>

        {/* Sources toggle button */}
        {onToggleSourcesTab && (
          <button
            onClick={onToggleSourcesTab}
            className={`flex items-center px-2 py-1 rounded-lg text-sm font-medium ${
              showSourcesTab ? "bg-accent-main text-primary-inverse" : "hover:bg-hover text-tertiary"
            }`}
          >
            <svg className="h-4 w-4 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Sources
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatHeader;
